/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./look.vue?vue&type=template&id=06a0af65&"
import script from "./look.vue?vue&type=script&lang=js&"
export * from "./look.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports